// extracted by mini-css-extract-plugin
export var catalog = "style-module--catalog--048e6";
export var title = "style-module--title--2d494";